<template>
  <Loader style="z-index: 1000;" v-if="loader" />

    <div class="flex justify-content-between align-items-center mb-3">
        <h2 class="m-0">Qualità Agenti Firmatari</h2>
    </div>

    <div class="flex flex-wrap gap-2 mb-3 mt-5 align-items-end">

        <div class="p-field">
            <label for="mese" class="m-3">Da:</label>
            <Calendar id="mese" v-model="dati.data_inizio" dateFormat="dd-mm-yy" />
        </div>
        
        <div class="p-field">
            <label for="mese-fine" class="m-3">A:</label>
            <Calendar id="mese-fine" v-model="dati.data_fine" dateFormat="dd-mm-yy" />
        </div>

        <div class="p-field ml-3">
            <Button label="CERCA" icon="pi pi-search" class="p-button-info" @click="getQualitaAgentiFirmatari()" />
        </div>

    </div>

    <div>
        <DataTable
            :value="dati.rows"
            responsiveLayout="scroll"
            paginator
            :rows="10"
            :rowsPerPageOptions="[10, 25, 50, 100]"
            currentPageReportTemplate="Visualizzazione {first} - {last} di {totalRecords}"
            :sortField="'fatturato'"
            :sortOrder="-1"
        >
            <Column field="fatturato" header="Fatturato" sortable>
            <template #body="{ data }">
                {{ formatCurrency(data.fatturato) }}
            </template>
            </Column>

            <Column field="saldo" header="Saldo" sortable>
            <template #body="{ data }">
                {{ formatCurrency(data.saldo) }}
            </template>
            </Column>

            <Column field="pagato" header="Pagato" sortable>
            <template #body="{ data }">
                {{ formatCurrency(data.pagato) }}
            </template>
            </Column>

            <Column field="quantefatture" header="Numero Fatture" sortable>
            <template #body="{ data }">
                {{ formatNumeroFatture(data.quantefatture) }}
            </template>
            </Column>

            <Column field="agenzia" header="Agenzia" sortable />
            <Column field="agentefirmatario" header="Agente Firmatario" sortable />
        </DataTable>

    </div>
</template>

<script>
import { ref, onMounted, getCurrentInstance, reactive } from "vue";
import Loader from "@/components/Loader.vue";
import Service from "@/services/ask-pratiche/pratiche-service";

export default {
  components: {
    Loader
  },
  setup() {
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const service = new Service(self.$http, self.$eventBus);
    const loader = ref(false);

    const dati = reactive({
        rows: [],
        data_inizio: null,
        data_fine: null
    });

    const formatDate = (date) => {
        if (!date) return null;
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const parseDateFromString = (str) => {
        if (!str) return null;
        const [day, month, year] = str.split(/[/-]/);
        return new Date(`${year}-${month}-${day}`);
    }

    const getQualitaAgentiFirmatari = () => {
        loader.value = true;

        const dataInizio = formatDate(dati.data_inizio);
        const dataFine = formatDate(dati.data_fine);

        service.getQualitaAgenteFirmatario(dataInizio, dataFine)
        .then(response => {
            if (response.items.success) {
                dati.rows = response.items.result;

                dati.data_inizio = parseDateFromString(response.items.data_inizio);
                dati.data_fine = parseDateFromString(response.items.data_fine);
            }
        })
        .catch(error => {
            console.error("Error fetching Qualita Agenti Firmatari:", error);
        })
        .finally(() => {
            loader.value = false;
        });
    };

    const formatCurrency = (val) => {
        if (typeof val !== "number") return '';
        return `${val.toLocaleString("it-IT", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })} €`;
    };

    const formatNumeroFatture = (val) => {
        if (typeof val !== "number") return '';
        return val.toLocaleString("it-IT");
    };
    
    onMounted(() => {
      getQualitaAgentiFirmatari();
    });

    return {
      loader,
      dati,
      getQualitaAgentiFirmatari,
      formatCurrency,
      formatNumeroFatture
    };
  }
}
</script>

<style scoped>
</style>